import insight from './images/insight.svg';
import info from './images/info.svg';
import {OPTION_INPUT_TYPES} from './enums';


export const optionsPageDetails = {
    mainHeading: "הי CUSTOMER_NAME, כייף שבחרת לצרף קו\n לתוכניות המיוחדות לבני המשפחה",
    secondaryHeading: "מה תרצו לעשות?",
    options: [
      {
        optionType: OPTION_INPUT_TYPES.NEW_LINE,
        heading: "לרכוש קו חדש",
        checkedInputObj: {
          heading: "",
          secondaryGrayHeadingIconUrl: info,
          secondaryGrayHeading: "הקו החדש יוקם תחת מס' ת.ז שלך",
          linkText: "אפשרויות נוספות",
          popUp:{
            icon:insight,
            heading:"כדי לרכוש קו חדש תחת ת.ז חדשה ולצרפו לתוכניות בני משפחה",
            secondaryHeading:`תחילה יש לרכוש קו חדש ב${window.Config.brand_Name_HE} ולאחר מכן לצרפו לתוכנית בני משפחות`,
            buttonText:"הבנתי, תודה",
          },
          linkUrl: "",
          textInput: {},
        },
      },
      {
        optionType: OPTION_INPUT_TYPES.TRANSFER_LINE,
        heading: "לנייד קו מחברה אחרת",
        checkedInputObj: {
          heading: "איזה מספר אנחנו מניידים?",
          secondaryGrayHeadingIconUrl: "",
          secondaryGrayHeading:
          `מספר הטלפון אותו תרצו לנייד ל${window.Config.brand_Name_HE} יקבל בדקות הקרובות לינק ב-SMS לצורך השלמת הניוד`,
          linkText: "",
          linkUrl: "",
          textInput: {
            placeholder: "מספר טלפון לניוד",
            inputType: "tel",
            required: true,
          },
        },
      },
      {
        optionType: OPTION_INPUT_TYPES.CHANGE_PACKAGE,
        heading: `לצרף קו קיים ב${window.Config.brand_Name_HE} לתוכנית בן משפחה`,  
      },
    ],
    buttonText: "אישור והמשך",
  };

 


 